import { render } from "./InitiateSendMoney.vue?vue&type=template&id=5687ef3f"
import script from "./InitiateSendMoney.vue?vue&type=script&lang=js"
export * from "./InitiateSendMoney.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__